// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__vJWMl","title":"ClientReferral_title__21vqW","itemText":"ClientReferral_itemText__TbXoh"};